import React, { useEffect } from "react";
import "./Team.css";
import AOS from "aos";
import "aos/dist/aos.css";

// Team members data
const teamMembers = [
  { name: "John Doe", role: "Senior Inspector" },
  { name: "Jane Smith", role: "Quality Analyst" },
  { name: "Robert Johnson", role: "Mechanical Engineer" },
  { name: "Emily Davis", role: "NDT Specialist" },
  { name: "Michael Brown", role: "Inspection Supervisor" },
];

// Function to get initials
const getInitials = (name) => {
  return name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase();
};

const Team = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div>
      {/* Hero Section */}
      <section
        className="team-hero-section"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL + "/images/hero1.jpg"})`,
        }}
      >
        <div className="overlay"></div>
        <div className="team-hero-content" data-aos="fade-up">
          <h1>Our Team</h1>
          <p>Meet the talented team behind Riksons Inspection Services</p>
        </div>
      </section>

      {/* Team Info */}
      <section className="team-info" data-aos="fade-up">
        <div className="team-intro">
          <p>
            There are totally 50 members working in our “Riksons” team. All team members are well qualified with Diploma & Degree in Mechanical and ASNT Level II (All Methods).
          </p>
        </div>
      </section>

      {/* Team Members Grid */}
      <section className="team-members">
        {teamMembers.map((member, index) => (
          <div
            className="team-card"
            key={index}
            data-aos="fade-up"
            data-aos-delay={index * 100}
          >
            <div className="team-avatar">
              <span>{getInitials(member.name)}</span>
            </div>
            <h3>{member.name}</h3>
            <p>{member.role}</p>
          </div>
        ))}
      </section>
    </div>
  );
};

export default Team;
